import { authenticatedFetch, jsonFetch, backendUrl } from "@/data/http"

// Wire shape matches AddDevicePatientAppDtoV1 on the backend
export type AddDeviceApiDto = {
  deviceCode: string
}

// Wire shape matches DeviceSelfRegistrationSuccessDto.Code (kebab-cased)
export type AddDeviceResponse = {
  code: "device-assigned-successfully" | "device-already-assigned"
}

export const addDevice = ({ patientId, deviceCode }: { patientId: string; deviceCode: string }) =>
  authenticatedFetch<AddDeviceResponse>(
    `${backendUrl}/v1/patients/${patientId}/devices`,
    { method: "POST", body: JSON.stringify({ deviceCode } satisfies AddDeviceApiDto) },
  )

// Wire shape matches SelfRegisterDeviceApiDtoV1 on the backend
export type SelfRegisterDeviceApiDto = {
  phoneNumber: string  // E.164 format e.g. "+13105551234"
  deviceCode: string
}

export const selfRegisterDevice = (params: SelfRegisterDeviceApiDto) =>
  jsonFetch<void>(
    `${backendUrl}/v1/self-register-device`,
    { method: "POST", body: JSON.stringify(params) },
  )
